<template>
  <div class="account-billing-history">
    <h1 class="h3 mb-4">Billing History</h1>
    <div v-if="transactions.length > 0">
      <b-card
        class="mb-2"
        :key="entry.id"
        v-for="entry in transactions">
        <div class="d-flex justify-content-between">
          <div>
            <p class="text-muted">
              {{ entry.createdAt | date }}
            </p>
            <div>
              <span class="h5">
                {{ entry.listingTitle }}
              </span>
            </div>
            <p>
              {{ entry.description }}
            </p>
            <p
              class="text-muted mb-0">
              Reference #: {{ entry.reference }}
            </p>
          </div>
          <div>
            <span
              class="h5">
              {{ entry.amount | currency }}
            </span>
          </div>
        </div>
        <hr>
        <h3 class="h5 mb-1">
          Actions
        </h3>
        <div>
          <span class="mr-3">
            <a
              class="font-weight-bold"
              href="mailto:support@zooplocal.com">
              Contact Support
            </a>
          </span>
          <span class="mr-3">
            <router-link
              class="font-weight-bold"
              :to="`/listing/${entry.listingId}`"
              target="_blank">
              Preview Listing
            </router-link>
            <span class="text-muted ml-1">
              (link opens in a new tab)
            </span>
          </span>
        </div>
      </b-card>
    </div>
    <div v-else>
      <b-card
        class="py-5 text-center">
        <h4 class="h5">
          You haven't made any payments on ZoopLocal
        </h4>
        <p>
          Any payments you make on ZoopLocal will be appear
          here for your records.
        </p>
        <b-button
          @click="$router.push('/account/listings/new')"
          size="md"
          variant="outline-dark"
          squared>
          Start Selling
        </b-button>
      </b-card>
    </div>
  </div>
</template>

<script>
import currency from '@/filters/currency.filter'
import date from '@/filters/date.filter'

export default {
  name: 'AccountBillingHistory',
  filters: {
    date,
    currency,
  },
  data() {
    return {
      transactions: [],
    }
  },
  methods: {
    async fetchTransactions() {
      const { data: { transactions } } = await this.$http.get('/transactions')
      this.transactions = transactions
    },
  },
  created() {
    this.fetchTransactions()
  },
}
</script>
